import * as React from "react";

function BoltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M289.7 0c19.1 0 32.9 18.26 27.7 36.61L263.8 224h85.3c19.3 0 34.9 15.6 34.9 34.9 0 10.3-4.5 20-12.3 26.7L112.9 505.2c-5.2 4.4-11.8 6.8-18.63 6.8-19.09 0-32.87-18.3-27.63-36.6L120.2 288H33.74C15.1 288 0 272.9 0 254.3c0-9.9 4.315-19.3 11.81-25.7L271.1 6.893A28.634 28.634 0 0 1 289.7 0zm-36.1 84.99L72.36 240H152c7.5 0 14.6 3.5 19.2 9.5 4.5 6.1 5.9 13.9 3.9 21.1l-44.8 156.9L313.5 272H232c-7.5 0-14.6-3.5-19.2-9.5-4.5-6.1-5.9-13.9-3.9-21.1l44.7-156.41z"
  }));
}

const ForwardRef = React.forwardRef(BoltIcon);
export default ForwardRef;